import classnames from 'classnames';
import React, { forwardRef, ReactNode } from 'react';

import * as styles from './table.module.scss';

type TableBodyProps = { children: ReactNode; bordered?: boolean; className?: string[] };

export default forwardRef<HTMLTableSectionElement, TableBodyProps>((props, ref) => {
  const css = classnames([styles.Table__Body, { [styles['Table__Body--bordered']]: props.bordered }, props.className]);
  return (
    <tbody ref={ref} className={css}>
      {props.children}
    </tbody>
  );
});
